export const GENDER = [
    { label: 'Male', value: "male" },
    { label: 'Female', value: "female" }
] 
export const verificationOptions = [
    { label: 'Verified', value: "verified" },
    { label: 'Waitlisted', value: "waitlisted" },
    { label: 'Requested', value: "requested" },
    { label: 'Pending', value: "pending" },
] 

export const relationshipStatusOptions = [
    { value: 'single', label: 'Single' },
    { value: 'couple', label: 'Couple' },
]

export const singlesMartialStatusOPtions = [
    { label: 'Unmarried', value: "unmarried" },
    { label: 'Divorced', value: "divorced" },
    { label: 'Widowed', value: "widowed" }
]

export const couplesMartialStatusOPtions = [
    { label: 'In a relationship', value: "in_a_relationship" },
    { label: 'Engaged', value: "engaged" },
    { label: 'Married', value: "married" }
]


export const singlesLookingForOptions = [
    { value: 'marriage', label: 'Marriage' },
    { value: 'dating', label: 'Dating' },
    { value: 'friendship', label: 'Friendship' },
    { value: 'im_not_sure_yet', label: 'Im not sure yet' },
]
export const couplesLookingForOptionsCouples = [
    { value: 'meetup', label: 'Meetup' },
    { value: 'events', label: 'Events' },
    { value: 'friendship', label: 'Friendship' },
    { value: 'im_not_sure_yet', label: 'Im not sure yet' },
]

export const interests = [
    { value: 'reading', label: 'Reading' },
    { value: 'photography', label: 'Photography' },
    { value: 'gaming', label: 'Gaming' },
    { value: 'music', label: 'Music' },
    { value: 'travel', label: 'Travel' },
    { value: 'painting', label: 'Painting' },
    { value: 'politics', label: 'Politics' },
    { value: 'charity', label: 'Charity' },
    { value: 'cooking', label: 'Cooking' },
    { value: 'pets', label: 'Pets' },
    { value: 'sports', label: 'Sports' },
    { value: 'fashion', label: 'Fashion' },
] 

export const filterSectionInterests = [
    { value: 'Reading', label: 'Reading' },
    { value: 'Photography', label: 'Photography' },
    { value: 'Gaming', label: 'Gaming' },
    { value: 'Music', label: 'Music' },
    { value: 'Travel', label: 'Travel' },
    { value: 'Painting', label: 'Painting' },
    { value: 'Politics', label: 'Politics' },
    { value: 'Charity', label: 'Charity' },
    { value: 'Cooking', label: 'Cooking' },
    { value: 'Pets', label: 'Pets' },
    { value: 'Sports', label: 'Sports' },
    { value: 'Fashion', label: 'Fashion' },
] 

export const physicalStatusOptions = [
    { value: 'none', label: 'None' },
    { value: 'disabled', label: 'Disabled Person' },
]


// Diet Options
export const drinkingOptions = [
    { value: 'non_drinker', label: 'Non Drinker' },
    { value: 'social_drinker', label: 'Social Drinker' },
]

export const smokingOptions = [
    { value: 'non_smoker', label: 'Non Smoker' },
    { value: 'occasional_smoker', label: 'Occasional Smoker' },
]

export const eatingOptions = [
    { value: 'omnivore', label: 'Omnivore' },
    { value: 'Vegetarian/Vegan', label: 'Vegetarian/Vegan' },
    { value: "i'm_flexible", label: "I'm Flexible" },
]

export const workoutOptions = [
    { value: 'regularly', label: 'Regularly' },
    { value: 'weekly', label: 'Weekly' },
    { value: "sometimes", label: "Sometimes" },
    { value: "not_do", label: "Not do" },
]

export const educationOptions = [
    { value: 'under_graduate', label: 'Under Graduate' },
    { value: 'post_graduate', label: 'Post Graduate' },
    { value: "12th", label: "12th" },
    { value: "any", label: "Any" },
]

export const relationWithParent = [
    { value: 'father', label: 'Father' },
    { value: 'mother', label: 'Mother' },
    { value: 'brother', label: 'Brother' },
    { value: 'sister', label: 'Sister' },
]

export const contactModeWithParent = [
    { value: 'phone', label: 'Phone' },
    { value: 'email', label: 'Email' },
    { value: 'in_person', label: 'In Person' },
]

export const timeLineOptions = [
    { value: 'less_than_6_months', label: 'Less than 6 months' },
    { value: '1_year', label: '1 Years' },
    { value: '1-2_year', label: '1-2 Years' },
]

export const genderOptions = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Unisex', value: 'unisex' },
];
  
export const accountStatus = [
    { label: 'Blocked', value: true },
    { label: 'Active', value: false }
]

export const boolean = [
    { label: 'True', value: true },
    { label: 'False', value: false }
]
export const eventMode = [
    { label: "Online", value: "online" },
    { label: "Offline", value: "offline" }
]

export const verificationStatus = [
    { label: 'Requested', value: 'requested' },
    { label: 'Verified', value: 'verified' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Waitlist', value: 'waitlist' },
] 

export const eventStatus = [
    { label: 'Draft', value: 'draft' },
    { label: 'Published', value: 'published' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Completed', value: 'completed' },
]

export const coupleAndPerson = [
    { label: "Couples", value: "couple" },
    { label: "Person", value: "person" }
]

export const debitAndCredit = [
    { label: "Debit", value: "debit" },
    { label: "Credit", value: "credit" }
]

export const enquiryStatus = [
    { label: "Submit", value: "submit" },
    { label: "Solved", value: "solved" }
]

// ===== USER ACTIVITY =====
export const user_activity_actions = [
        'updated_new_location',
        'trigger_matches',

        'connection_request_sent',
        'connection_request_received',
        'connection_request_removed',
        'connection_request_rejected',
        'connection_request_accepted',
        
        'wallet_custom_recharge',
        'plan_upgrade',
         
        'signup',
        'onboarding',
        'login',
         
        'uploaded_new_image',
        'profile_edit',
        'basic_filter_edit',
        'advanced_filter_edit',
        'event_connection_request_sent',
        'handpick_connection_request_sent',
        'handpick_connection_request_received',
        'event_connection_request_received',
        'handpick_connection_request_sent_received',
        'qr_connection_request_sent',
        'mutual_contacts_connection_request_sent',
        'mutual_contacts_connection_request_received',
        'nearby_connection_request_sent',
        'nearby_connection_request_received',
         'new_qr_code_generated',
         'looking_for_connection_request_sent',
         'interest_connection_request_sent',
         'unmatch_a_friend',
         'updated_new_email',
         'updated_phone_number',
        'submitted_verification_request',
        'submitted_reverfification_request',
         'updated_privacy_settings',
         'event_booked',
         'event_prebooked',
         'new_event_comment',
         'cancelled_event',
         'user_logout',
]